<template>
  <div class="nlp__subscribe-box">
    <div class="nlp__subscribe-background">
      <NlpSubscribeBackground />
    </div>
    <div class="nlp__subscribe-wrapper">
      <h2>Crypto News by Email</h2>
      <p>Subscribe to get insights and the latest crypto news.</p>
      <NlpSubscribeBar />
    </div>
  </div>
</template>

<script>
// Components
import NlpSubscribeBackground from '@/pages/landing-page/svg/NlpSubscribeBackground.vue'
import NlpSubscribeBar from '@/pages/landing-page/components/NlpSubscribeBar.vue'

export default {
  name: 'NlpCheckAddress',
  components: {
    NlpSubscribeBackground,
    NlpSubscribeBar,
  },
}
</script>

<style scoped>
.nlp__subscribe-box {
  padding: 64px 64px 80px 64px;
  background: linear-gradient(94.33deg, #194BFB 0%, #1800D1 121.58%);
  border: 1px solid #E2E9F6;
  border-radius: 24px;
  box-shadow: 2px 2px 4px 0px #B8C2DB40;
  position: relative;
}
.nlp__subscribe-box h2 {
  margin-bottom: 12px;
  color: #fff;
  text-align: left;
}
.nlp__subscribe-box p {
  margin-bottom: 32px;
  font-size: 16px;
  color: #fff;
}
.nlp__subscribe-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
}
.nlp__subscribe-background svg {
  width: auto;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
}
.nlp__subscribe-wrapper {
  position: relative;
  z-index: 2;
}

@media (max-width: 1279px) {
  .nlp__subscribe-box {
    padding: 64px 40px 80px 40px;
  }
}
@media (max-width: 767px) {
  .nlp__subscribe-box {
    padding: 64px 16px 80px 16px;
    border-radius: 0;
  }
  .nlp__subscribe-background {
    opacity: 0.5;
  }
  .nlp__subscribe-box h2,
  .nlp__subscribe-box p {
    text-align: center;
  }
}
</style>